<template>
  <div>
    <el-divider class="cml-divider" content-position="center">样品审核权限</el-divider>
    <el-form
      @submit.native.prevent
      ref="listForm"
      :inline="true"
      size="mini"
      style="margin-left: 20px"
    >
      <el-form-item label="花名">
        <el-input
          v-model.trim="tableParam.data.loginName"
          @keyup.13.native="onSearch"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="space-around">
      <el-col :span="10">
        <CommonTable
          ref="CommonTableRef"
          :showCheckbox="false"
          :loading="tableLoading"
          :tableHead="tableHead"
          :tableData="tableData"
          :tableParam="tableParam"
          :layouts="['JumpNumber', 'FullJump', 'Total']"
          @page-size-change="pageSizeChange"
          @radio-change="radioChange"
        >
          <template #operation="{row, rowIndex}">
            <el-button
              size="small"
              type="text"
              @click.stop="addBtn(row, rowIndex)"
            >绑定供应商</el-button>
          </template>
        </CommonTable>
      </el-col>
      <el-col :span="13">
        <CommonTable
          ref="CommonTableRef2"
          :showCheckbox="false"
          :tableParam="tableRef2Param"
          :loading="CommonTableRef2Load"
          :showPage="false"
          :tableHead="tableHead2"
          :tableData="tableData2"
        >
          <template #operation="{rowIndex}">
            <el-button
              size="small"
              type="text"
              @click="deleteBtn(rowIndex)"
            >删除</el-button>
          </template>
          <template #categoryName="{row}">
            <el-select v-model="row.sampleTypes" multiple placeholder="请选择">
              <el-option
                v-for="item in row.allSampleTypeVOS"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
          </template>
        </CommonTable>
        <el-button
          size="small"
          style="margin: 10px 0 0 45%"
          type="primary"
          :loading="saveLoading"
          @click="saveBtn('update')"
        >保 存</el-button>
      </el-col>
    </el-row>
    <el-dialog
      :title="'【' + loginName + '】' + '绑定供应商'"
      width="80%"
      :append-to-body="true"
      :visible.sync="dialogVisible"
    >
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form @submit.native.prevent :inline="true" size="mini">
            <el-form-item label="供应商" prop="name">
              <el-input
                v-model.trim="formData.name"
                @keyup.13.native="getSupplier"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="供应商类型" prop="categoryList">
              <DictSelect
                multiple
                type="cml_sample_type"
                :value="formData.categoryList"
                @change-emit="value => (formData.categoryList = value)"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getSupplier">查询</el-button>
              <el-button type="primary" @click="onReset">清空</el-button>
            </el-form-item>
          </el-form>
          <vxe-table
            border
            show-overflow
            size="mini"
            ref="supplierTable"
            height="500"
            v-loading="supplierTableLoading"
            :data="supplierListFilter"
            :row-config="{isHover: true}"
            :sort-config="{trigger: 'cell'}"
            @checkbox-change="addCheckboxChange"
            @checkbox-all="addCheckboxChange"
          >
            <vxe-column type="checkbox" width="50"></vxe-column>
            <vxe-column type="seq" width="60" title="序号"></vxe-column>
            <vxe-column field="name" title="供应商"></vxe-column>
            <vxe-column field="categoryName" title="样品类型">
            </vxe-column>
          </vxe-table>
        </el-col>
        <el-col :span="12">
          <div style="color:#AB0003; margin-bottom: 10px; height: 38px; line-height: 38px;"><i class="el-icon-star-on"></i>已选中数据</div>
          <vxe-table
            border
            show-overflow
            size="mini"
            ref="addSupplierTable"
            height="500"
            row-id="id"
            :data="addSelectData"
            :row-config="{isHover: true}"
            :sort-config="{trigger: 'cell'}">
            <vxe-column type="seq" width="60" title="序号"></vxe-column>
            <vxe-column field="name" title="供应商"></vxe-column>
            <vxe-column field="categoryName" title="样品类型">
              <template v-slot="{row}">
                <el-select v-model="row.sampleTypes" multiple placeholder="请选择">
                  <el-option
                    v-for="item in row.sampleTypeVOS"
                    :key="item.type"
                    :label="item.name"
                    :value="item.type">
                  </el-option>
                </el-select>
              </template>
            </vxe-column>
          </vxe-table>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="saveBtn('add')" :loading="addSaveLoading">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CommonTable from '@/components/CommonTable';
import DictSelect from '@/components/DictSelect';
import { mapGetters } from 'vuex';

export default {
  name: 'data-permission',
  components: {
    CommonTable,
    DictSelect,
  },
  data() {
    return {
      supplierTableLoading: false,
      currentData: [],
      loginName: '',
      dialogVisible: false,
      tableLoading: false,
      saveLoading: false,
      CommonTableRef2Load: false,
      tableParam: {
        pageNo: 1,
        pageSize: 20,
        data: {
          loginName: '',
          customerId: '0',
        },
      },
      tableRef2Param: {
        pageSize: 5000,
        pageNo: 1,
        orderBy: 'update_date',
      },
      formData: {
        name: '',
        categoryList: [],
      },
      tableData: {},
      tableData2: {
        list: []
      },
      tableHead: [
        { prop: 'loginName', label: '花名' },
        { prop: 'account', label: '登录名' },
        { prop: 'operation', label: '操作',slotColumn: true, slotName: 'operation', width: 140 },
      ],
      tableHead2: [
        { prop: 'supplierName', label: '供应商' },
        { prop: 'categoryName', label: '样品类型',slotColumn: true, slotName: 'categoryName' },
        { prop: 'operation', label: '操作',slotColumn: true, slotName: 'operation', width: 140 },
      ],
      selectData: {},
      deleteIndex: -1,
      deleteLoading: false,
      supplierList: [],
      addSelectData: [],
      addSaveLoading: false,
      supplierListFilter: []
    };
  },
  computed: {
    ...mapGetters(['allDictListData'])
  },
  mounted() {
    this.getUser();
    this.getSupplier();
    this.$refs.CommonTableRef.changeHeight(140);
    this.$refs.CommonTableRef2.changeHeight(140);
  },
  methods: {
    // 合并去重
    mergeBySupplyId(newArr, oldArr) {
      for (let supply of oldArr) {
        if (newArr.some((e) => e.code === supply.code)) continue;
        newArr.push(supply);
      }
      return newArr;
    },
    addCheckboxChange ({ records }) {
      this.addSelectData = this.mergeBySupplyId(records, this.addSelectData).map(item => ({
        ...item,
        sampleTypes: [item.sampleTypeVOS[0].type]
      }))
    },
    addBtn (row) {
      this.selectData = row;
      this.dialogVisible = true;
      this.loginName = row.loginName;
      this.addSelectData = [];
      this.formData = {
        name: '',
        categoryList: [],
      };
      this.supplierListFilter = [];
      this.$http.setting.getListAllByUserId(row.id).then(result => {
        this.$nextTick(() => {
          this.$refs.addSupplierTable.clearAll();
        })
        this.currentData = result.data;
        const codes = result.data.map(item => item.supplierCode)
        this.supplierListFilter = this.supplierList.filter(item => !codes.includes(item.code))
      }).catch(err => {
        this.$message.error(err.msg);
      }).finally(() => {
        this.CommonTableRef2Load = false
      });
    },
    deleteBtn (index) {
      this.tableData2.list.splice(index, 1)
    },
    onSearch() {
      this.tableParam.pageNo = 1;
      this.getUser();
      this.$refs.CommonTableRef2.clearCheckboxRow();
    },
    getUser() {
      this.tableLoading = true
      this.$http.setting
        .getUserList(this.tableParam)
        .then(result => {
          this.tableData = result.data;
          this.selectData = {};
        })
        .catch(err => {
          this.$message.error(err.msg);
        }).finally(() => {this.tableLoading = false})
    },
    getSupplier() {
      this.$refs.CommonTableRef2.scrollTo(0)
      const params = {
        ...this.tableRef2Param,
        data: this.formData
      }
      this.supplierTableLoading = true;
      this.$http.setting
        .getSupplierList(params)
        .then(result => {
          if (this.currentData.length > 0) {
            const codes = this.currentData.map(item => item.supplierCode)
            this.supplierListFilter = result.data.list.filter(item => !codes.includes(item.code))
          } else {
            this.supplierList = result.data.list;
            this.supplierListFilter = result.data.list;
          }
        })
        .catch(err => {
          this.$message.error(err.msg);
        }).finally(() => {
          this.supplierTableLoading = false;
        })
    },
    onReset() {
      this.formData.name = '';
      this.formData.categoryList = [];
      this.getSupplier();
    },
    saveBtn(type) {
      const arr = type === 'update' ? this.tableData2.list : [
        ...this.addSelectData,
        ...this.tableData2.list
      ];
      const params = arr.map(item => {
        return {
          loginName: this.selectData.loginName,
          supplierCode: item.supplierCode || item.code,
          supplierName: item.supplierName || item.name,
          userId: this.selectData.id,
          sampleTypes: item.sampleTypes
        };
      });
      const isTrue = params.every(item => item.sampleTypes && item.sampleTypes.length > 0)
      if(!isTrue) {
        this.$message.error('供应商类型不能为空！')
        return false
      }
      type === 'update' ? this.saveLoading = true : this.addSaveLoading = true;
      this.$http.setting
        .batchCreateUserSupplierRelation(params)
        .then(result => {
          this.$message.success(result.msg);
          this.onReset();
          this.dialogVisible = false;
          this.radioChange(this.selectData)
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          type === 'update' ? this.saveLoading = false : this.addSaveLoading = false;
        });
    },
    radioChange(obj) {
      this.selectData = obj;
      this.$refs.CommonTableRef2.clearCheckboxRow();
      // 获取用户权限
      this.$nextTick(() => {
      this.CommonTableRef2Load = true
      this.$http.setting
        .getListAllByUserId(obj.id)
        .then(result => {
          this.tableData2.list = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        }).finally(() => {
          this.CommonTableRef2Load = false
        });
      });
    },
    pageSizeChange(pageNo, pageSize) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getUser();
    },
  },
};
</script>
